import { jsx as _jsx } from "react/jsx-runtime";
import { useWatch } from 'react-hook-form';
import CheckboxButton from '../../../../app/common/CheckboxButton';
export var SelectAll = function (props) {
    var formValues = useWatch({
        control: props.form.control,
    });
    var areAllSelected = props.shops.every(function (shop) { return formValues[shop.id].enabled; });
    var toggleAllSelected = function () {
        var nextValue = !areAllSelected;
        props.shops.forEach(function (shop) {
            props.form.setValue("".concat(shop.id, ".enabled"), nextValue, {
                // required to trigger update
                shouldDirty: true,
                shouldValidate: true,
                shouldTouch: true,
            });
        });
    };
    return (_jsx(CheckboxButton, { onClick: toggleAllSelected, label: "Select All", checkedLabel: "Deselect All", checked: areAllSelected }));
};
